// extracted by mini-css-extract-plugin
export default {"MarxentClient":"marxent-client-module_MarxentClient_plsjE"};